import { useEffect, useState, useMemo } from 'react'
import { UserContext } from './UserContext'
import { DEFAULT_USER } from '../../../constants'

export function UserProvider({ children }) {
    const [currentUser, setCurrentUser] = useState({
        ...DEFAULT_USER,
        loading: true
    })

    useEffect(() => {
        fetch('/api/auth/user', {
            method: 'GET'
        })
            .then((response) => {
                if (response.status === 200) return response.json()
                console.error('Error loadign cart', response)
                throw new Error('Error loadign cart')
            })
            .then(({ id, first_name, last_name, role }) => {
                if (id > 0)
                    setCurrentUser({
                        role: role,
                        isLoggedIn: true,
                        first_name: first_name,
                        last_name: last_name,
                        loading: false
                    })
                else
                    setCurrentUser({
                        ...DEFAULT_USER,
                        isLoggedIn: false,
                        loading: false
                    })
            })
    }, [])

    const enhancedUser = useMemo(
        () => ({
            ...currentUser,
            logout: () => {
                setCurrentUser({
                    isLoggedIn: false,
                    first_name: '',
                    lnlast_nameame: ''
                })
            },
            login: ({ first_name, last_name }) => {
                setCurrentUser({
                    isLoggedIn: true,
                    first_name: first_name,
                    last_name: last_name
                })
            }
        }),
        [currentUser]
    )

    return <UserContext.Provider value={enhancedUser}>{children}</UserContext.Provider>
}
